import { createInputs } from '../../utils';

export default createInputs([
  { name: 'currentStep', type: 'number', required: false },
  { name: 'totalSteps', type: 'number', required: false },
  { name: 'order', type: 'string', required: true },
  { name: 'reward', type: 'string', required: true },
  { name: 'conditions', type: 'string', required: false },
]);
